export default class ContactNameUtil {

	public static extractGivenName(input: string): string {
		const givenName = this.replaceMultiSpaceWithSingle(input.trim());
		if (!givenName) {
			return '';
		}
		if (givenName.includes(' ')) {
			return givenName.substring(0, givenName.indexOf(' ')).trim();
		}
		return givenName;
	}

	public static extractSurname(input: string): string {
		const surname = this.replaceMultiSpaceWithSingle(input.trim());
		if (!surname) {
			return '';
		} else if (surname.includes(' ')) {
			return surname.substring(surname.indexOf(' ') + 1).trim();
		}
		return '';
	}

	public static replaceMultiSpaceWithSingle(input: string): string {
		return input.replace(/\s\s+/g, ' ');
	}
}


